/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

import '@oat-sa-private/ui-core/polyfills.js';
import router from './core/router';
import { __ } from '@oat-sa-private/ui-core';
import './index.css';

if (window.env) {
    window.console.info(`tao-deliver-app v${window.env.PACKAGE_VERSION || '?'} (build: ${window.env.VERSION || '?'})`);
}

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        const pathPrefix = window.env.PATH_PREFIX.replace(/\/+$/, '');
        const path = `${window.location.origin}/${pathPrefix}/sw.js`;
        navigator.serviceWorker.register(path.replace(/([^:]\/)\/+/g, "$1"));
    });
}

const localeFallback = 'en-US';
/**
 * Dynamically import a dictionary from a locale
 * @param {string} locale - the locale to load
 * @returns {Promise<Object>} resolves with the dictionary
 */
function loadDictionary(locale) {
    //if the locale use the underscore separator, replace it
    if (locale && /^[a-z]{2}_[A-Z]{2}/.test(locale)) {
        locale = locale.replace(/_/g, '-');
    }
    return import(`../locale/${locale}/messages.json`);
}

//register the dictionary loader
__.setDictionaryLoader(locale =>
    loadDictionary(locale)
        .catch(() => loadDictionary(localeFallback))
        .then(dictionaryModule => dictionaryModule.default)
);

router.start();
